import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { AddonsVersionProCancelPage } from '../addons-version-pro-cancel/addons-version-pro-cancel';
import { ConfigurationPage } from '../../configuration/configuration';
import { HttpClient, HttpParams } from '@angular/common/http';



@Component({
  selector: 'page-addons-version-pro',
  templateUrl: 'addons-version-pro.html',
})
export class AddonsVersionProPage {

  transactions_list = [];
  loader_invoices = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient) {

  }

  ionViewWillEnter() {
    this.getAllSuscriptionTransactions();
  }

  close() {
    this.globals.side_menu_config_active = '';
    if (this.navCtrl.canGoBack()) {
      this.navCtrl.pop();
    } else {
      this.navCtrl.setRoot(ConfigurationPage);
    }

  }

  openCancelVersionPro() {
    this.globals.side_menu_config_active = '';
    this.navCtrl.push(AddonsVersionProCancelPage);
  }

  getAllSuscriptionTransactions() {
    /*const params = new HttpParams()
      .set('facturacion_id', this.globals.restaurant.facturacion_id);
    this.http.post(this.globals.api_gestio_path + 'pro/list/pay/customer', params, {})
      .subscribe(async res => {
        this.transactions_list = res['suscriptions'];
      });*/
    const params = new HttpParams()
      .set('facturacion_id', this.globals.restaurant.facturacion_id);
    this.http.post(this.globals.analytics_path + 'pro/list/pay/customer', params, {})
      .subscribe(async res => {
        this.transactions_list = res['suscriptions'];
        this.loader_invoices = true;
      });
  }

  async openCancelSuscription() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('reason', 'Dar de baja porque se cierra por temporada, gracias.');
    this.http.post(this.globals.analytics_path + 'stripe/mct_suscription_cancel', params, {})
      .subscribe(async res => {
        if (res) {//dado de baja

        } else {//error al dar de baja

        }
      });
  }

  downloadInvoice(transaction) {
    if (this.globals.so_mobile) {
      window.location.assign(transaction.pdf_factura);
    } else {
      window.open(transaction.pdf_factura, '_blank');
    }
  }

  openUpdateVersion(){
    if (this.globals.so_mobile) {
      window.location.assign('https://mycheftool.com/tarifas');
    } else {
      window.open('https://mycheftool.com/tarifas', '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/addons/addons-version-pro/addons-version-pro.ts